import { FC } from "react";
import { getTrialLessonTagName, ITrialLesson } from "../../../../entities/trialLesson";
import { CALENDAR_DAY_SLOT_HEIGHT_PX } from "../../../../shared/lib/const/calendarDay";
import { StudentIcon, TutorIcon } from "../../../../shared/ui/icon";
import classes from '../trialCalendarDay.module.scss'

interface IProps {
    trialLesson: ITrialLesson;
    startIndex: number;
    endIndex: number;
    left: number;
    width: number;
    zIndex: number;
    visibleStartsAt: Date;
    visibleEndsAt: Date;
    formatTime: (date: Date) => string;
    statusClassName: string;
    onSelect: (trialLesson: ITrialLesson) => void;
}

export const TrialCalendarDayLessonBlock: FC<IProps> = ({
    trialLesson, startIndex, endIndex, left, width, zIndex, visibleStartsAt, visibleEndsAt,
    formatTime, statusClassName, onSelect,
}) => {
    const lessonTagName = getTrialLessonTagName(trialLesson)

    return (
        <button
            type="button"
            className={`${classes.trialLesson} ${statusClassName}`}
            style={{
                top: startIndex * CALENDAR_DAY_SLOT_HEIGHT_PX,
                height: Math.max(
                    (endIndex - startIndex) * CALENDAR_DAY_SLOT_HEIGHT_PX - 2,
                    CALENDAR_DAY_SLOT_HEIGHT_PX - 2
                ),
                left,
                width,
                maxWidth: `calc(100% - ${left}px)`,
                zIndex,
            }}
            title={
                `${formatTime(visibleStartsAt)}–${formatTime(visibleEndsAt)} · ` +
                `${trialLesson.studentName} · ${lessonTagName}`
            }
            onPointerDown={event => event.stopPropagation()}
            onClick={() => onSelect(trialLesson)}
        >
            <section className={classes.lessonHeader}>
                <strong className={classes.studentName}>
                    <StudentIcon size={15} />
                    {trialLesson.studentName}
                </strong>
                <span className={classes.lessonTime}>
                    {formatTime(visibleStartsAt)}–{formatTime(visibleEndsAt)}
                </span>
            </section>
            <span className={classes.lessonDetails}>
                <TutorIcon size={14} />
                <span>{trialLesson.tutor.fullName}</span>
                <span className={classes.lessonSubject}>{lessonTagName}</span>
            </span>
        </button>
    )
}
